import '../css/Nav.css';
import { Link, Outlet } from 'react-router-dom';

import { useUser } from '../hooks/useUser';

// import { useCart } from '../hooks/useCart';

export function Nav() {
  const { user, logout, isLoggedIn } = useUser();
  // console.log('USER IN NAV', user);
  //   const { cartCount } = useCart();
  //   const count = cartCount();

  return (
    <div className="navigation">
      <div className="nav-pane">
        {isLoggedIn() ? (
          <header className="user-nav">
            <img
              className="avatar"
              src={
                user?.avatar_url
                  ? user.avatar_url
                  : 'https://nqbvdgzoxvmdlnjovyqu.supabase.in/storage/v1/object/public/avatars/default-avatar/userexpression.png'
              }
              alt="PROFILE PIC"
            ></img>
            <h1 className="user-nav-greetings">{`Welcome ${user?.username}`}</h1>
            <span style={{ display: 'flex', flexDirection: 'column' }}>
              <span className="wallet-balance-display">
                Wallet Balance: ${user?.wallet?.balance === undefined ? '0' : user?.wallet?.balance}
              </span>
              <Link to={`/cart`} className="qr-link">
                <span className="cart-logo-and-count-container">
                  <img
                    // onClick={() => navigate('/cart')}
                    className="checkout-cart-logo"
                    src="../cart-icon.png"
                  ></img>
                  {/* {count > 0 && <span className="cart-length-indicator">{count}</span>} */}
                </span>
              </Link>
              {/* <Link to={`/live-space/${user?.user_id}`} className="qr-link">
                Start Live
              </Link> */}
            </span>
          </header>
        ) : null}
        <h2 className="site-motto-header" style={{ margin: 0 }}>
          Express Yourself and Connect With Others
        </h2>
        <nav className="nav-links-group">
          <Link className="nav-link" to="/">
            Home
          </Link>{' '}
          |{' '}
          <Link className="nav-link" to="/profile">
            Profile
          </Link>{' '}
          |{' '}
          <Link className="nav-link" to="/battle">
            Battle Field
          </Link>{' '}
          |{' '}
          <Link className="nav-link" to="/about">
            About
          </Link>{' '}
          |{' '}
          {isLoggedIn() ? (
            <button className="logout nav-link" onClick={logout}>
              Logout
            </button>
          ) : (
            <Link className="nav-link" to="/login">
              Sign In/Sign Up
            </Link>
          )}
        </nav>
        <Outlet />
      </div>
    </div>
  );
}
